var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"background-container"},[_c('div',{ref:"background",staticClass:"background-image blur"}),_c('img',{ref:"image",attrs:{"hidden":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }